<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <h5 class="card-title fw-bold mb-0">{{ this.tableTitle }}</h5>
        </div>
      </div>
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          
          <button :disabled="isBusy" @click="analyzeQuery" style="margin-right: 5px;" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
            <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
            </div>
            <div v-else>
              Analyze Query
              <i class="flaticon-check position-relative ms-5 fs-12"></i>
            </div>
            
          </button>

          <button @click="openAddFieldBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Field
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup v-if="isKey">
              <col style="width: 20%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
              <col style="width: 40%;">
              <col style="width: 20%;">
            </colgroup>
            <colgroup v-else>
              <col style="width: 50%;">
              <col style="width: 50%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Field
                </th>
                <th v-if="isKey" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Field Type
                </th>
                <th v-if="isKey" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Data Source Name
                </th>
                <th v-if="isKey" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Query
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Description
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(qwilrDefinitionField, index) in filteredQwilrDefinitionFields" :key="qwilrDefinitionField.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionField.field }}
                </th>
                <th v-if="isKey" class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ getEnumText(qwilrDefinitionField.fieldType) }}
                </th>
                <th v-if="isKey" class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionField.dataSourceName }}
                </th>
                <th v-if="isKey" class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionField.query }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionField.description }}
                </th>
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                  <div class="dropdown">
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li 
                        v-if="isKey" 
                        :class="{ 'disabled': index === 0 }"
                      >
                        <a 
                          class="dropdown-item d-flex align-items-center"
                          href="#" 
                          @click.prevent="index !== 0 && moveUp(index)"
                          :class="{ 'text-muted': index === 0 }"
                        >
                          <i
                            class="flaticon-up-arrow lh-1 me-8 position-relative top-1"
                            :class="{ 'opacity-50': index === 0 }"
                          ></i>
                          Move Up
                        </a>
                      </li>

                      <li 
                        v-if="isKey" 
                        :class="{ 'disabled': index === filteredQwilrDefinitionFields.length - 1 }"
                      >
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" 
                          @click.prevent="index !== filteredQwilrDefinitionFields.length - 1 && moveDown(index)"
                          :class="{ 'text-muted': index === filteredQwilrDefinitionFields.length - 1 }"
                        >
                          <i
                            class="flaticon-down-arrow lh-1 me-8 position-relative top-1"
                            :class="{ 'opacity-50': index === filteredQwilrDefinitionFields.length - 1 }"
                          ></i>
                          Move Down
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteField(qwilrDefinitionField.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateFieldBox(qwilrDefinitionField)"
                          ><i
                            class="flaticon-edit lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredQwilrDefinitionFields.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrDefinitionFields }}</span> results
          </p>
        </div>
      </div>

      <Lightbox v-if="showAddFieldBox" @close="closeAddFieldBox">
        <AddQwilrDefinitionField :qwilrDefinitionId="this.qwilrDefinitionId" :isKey="this.isKey" @fieldAdded="handleFieldAdded" @close="closeAddFieldBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateFieldBox" @close="closeUpdateFieldBox">
        <UpdateQwilrDefinitionField :field="this.selectedField" @fieldUpdated="handleFieldUpdated" @close="closeUpdateFieldBox"/>
      </Lightbox>

    </div>

  </template>
  
  <script>
  import { GetQwilrDefinitionFields, AddKeyFieldFromSqlParameter, AddContentFieldFormQuery, DeleteQwilrDefinitionFieldById, UpdateQwilrDefinitionFieldSequence } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  import AddQwilrDefinitionField from "./AddQwilrDefinitionField.vue";
  import UpdateQwilrDefinitionField from "./UpdateQwilrDefinitionField.vue";
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import { FieldType} from "@/core/constant/QueryFieldType";

  export default {
    name: "QwilrField",
    props: {
      isKey:{
        type: Boolean,
        required: true
      },
      tableTitle:{
        type: String,
        required: true
      }
    },
    components: {
      Lightbox,
      AddQwilrDefinitionField,
      UpdateQwilrDefinitionField
    },
    data() {
      return {
        searchQuery: "", 
        filteredQwilrDefinitionFields: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrDefinitionFields: 0, 
        totalPages: 1, 
        showAddFieldBox: false,
        showUpdateFieldBox: false,
        qwilrDefinitionId:null,
        selectedField:null,
        FieldType,
        isBusy:false
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrDefinitionFieldsByFilter(filter = "") {
        let data = await GetQwilrDefinitionFields(this.qwilrDefinitionId, this.isKey);
        if(data)
        {
          this.filteredQwilrDefinitionFields = data.qwilrDefinitionFields;
          this.totalQwilrDefinitionFields = data.qwilrDefinitionFields.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchQwilrDefinitionFieldsByFilter(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchQwilrDefinitionFieldsByFilter(this.searchQuery);
        }
      },
      async executeAnalyzeQuery(){
        const toast = useToast();

        if(this.isKey){
          const payload = { qwilrDefinitionId:this.qwilrDefinitionId};
          
          await AddKeyFieldFromSqlParameter(payload)
          .then(response => {
            if (response.status === 200) {
              toast.success('Query analyzed successfully!', {
                timeout: 2000
              })
              this.fetchQwilrDefinitionFieldsByFilter();
            }
          })
          .catch(ex => {
            const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
            console.log(ex);
            toast.error(`Failed to analyze query : ${errorMessage}`, {timeout: 2000,});
          })
        }else{
          const payload = { qwilrDefinitionId:this.qwilrDefinitionId};
          
          await AddContentFieldFormQuery(payload)
          .then(response => {
            if (response.status === 200) {
              toast.success('Query analyzed successfully!', {
                timeout: 2000
              })
              this.fetchQwilrDefinitionFieldsByFilter();
            }
          })
          .catch(ex => {
            const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
            console.log(ex);
            toast.error(`Failed to analyze query : ${errorMessage}`, {timeout: 2000,});
          })
        }
      },
      async analyzeQuery(){
        const toast = useToast();

        if (this.filteredQwilrDefinitionFields.length <= 0) {
          try {
            this.isBusy = true;
            setTimeout(async () => {
              try {
                await this.executeAnalyzeQuery();
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to generate field: ${errorMessage}`, {
                  timeout: 2000,
                });
              } finally {
                this.isBusy = false;
              }
            }, 1000);
          } catch (ex) {
            const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
            toast.error(`Failed to generate field: ${errorMessage}`, {
              timeout: 2000,
            });
          }
        } else {
          Swal.fire({
            title: 'Are you sure?',
            text: "This action will replace the existing field. Do you want to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(async (result) => {  
            if (result.isConfirmed) {
              try {
                this.isBusy = true;
                setTimeout(async () => {
                  try {
                    await this.executeAnalyzeQuery();
                  } catch (ex) {
                    const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                    toast.error(`Failed to generate field: ${errorMessage}`, {
                      timeout: 2000,
                    });
                  } finally {
                    this.isBusy = false;
                  }
                }, 1000);
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to generate field: ${errorMessage}`, {
                  timeout: 2000,
                });
              }
            } else {
              toast.info('Analyzing query canceled.', { timeout: 2000 });
            }
          });
        }
      },
      openAddFieldBox(){
        this.showAddFieldBox=true;
      },
      openUpdateFieldBox(field){
        this.selectedField=field;
        this.showUpdateFieldBox=true;
      },
      closeAddFieldBox(){
        this.showAddFieldBox=false;
      },
      closeUpdateFieldBox(){
        this.showUpdateFieldBox=false;
      },
      handleFieldAdded(){
        this.fetchQwilrDefinitionFieldsByFilter("");
      },
      handleFieldUpdated(){
        this.fetchQwilrDefinitionFieldsByFilter("");
      },
      async deleteField(fieldId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: fieldId };
              let response = await DeleteQwilrDefinitionFieldById(payload);  
              if (response.status === 200) {
                toast.success('Field deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrDefinitionFieldsByFilter("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete field: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Field deletion canceled.', { timeout: 2000 });
          }
        });

      },
      getEnumText(value) {
        const entry = Object.entries(FieldType).find(([key, val]) => val === value);
        return entry ? entry[0] : "Unknown"; 
      },
      async moveUp(index) {
      if (index > 0) {
        this.swapItems(index, index - 1);
        await this.updateSequence();
      }
      },
      async moveDown(index) {
        if (index < this.filteredQwilrDefinitionFields.length - 1) {
          this.swapItems(index, index + 1);
          await this.updateSequence();
        }
      },
      swapItems(fromIndex, toIndex) {
        const temp = this.filteredQwilrDefinitionFields[fromIndex];
        this.filteredQwilrDefinitionFields[fromIndex] = this.filteredQwilrDefinitionFields[toIndex];
        this.filteredQwilrDefinitionFields[toIndex] = temp;

        this.filteredQwilrDefinitionFields.forEach((item, i) => {
          item.sequence = i + 1;
        });
      },
      async updateSequence() {
        try {
          
          const payload = 
            { 
              fields:this.filteredQwilrDefinitionFields
            };
        
            await UpdateQwilrDefinitionFieldSequence(payload)
                    .then(response => {
                    if (response.status === 200) {
                      console.log('Sequence successfully updated in the database');
                    }
                    })
                    .catch(ex => {
                        const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                        console.log(errorMessage);
                        console.log('Sequence successfully updated in the database');
                    })

            } catch (error) {
              console.error("Failed to update sequence:", error);
            }
      }
    },
    created() {
      this.qwilrDefinitionId = this.$route.params.id;
      this.fetchQwilrDefinitionFieldsByFilter("");
    }
  };
  </script>

  <style scoped>
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  </style>


  